import { Skeleton } from "primereact/skeleton";
import { Divider } from "primereact/divider";

export function AchievementsSkeleton() {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading achievements"
      className="flex flex-col gap-[45px] pb-10"
    >
      <div className="flex gap-[250px]">
        <div className="flex flex-col pr-2 gap-3 min-w-[250px] w-[35%]">
          <Skeleton width="150px" height="1rem" />
          <Skeleton width="120px" height="2rem" />
          <Skeleton width="100%" height="16px" />
          <div>
            <Skeleton width="220px" height="1rem" />
            <Skeleton width="180px" height="1rem" className="mt-1" />
          </div>
          <Skeleton width="140px" height="40px" />
        </div>
        <div className="flex flex-col pl-2 gap-3">
          <Skeleton width="150px" height="1rem" />
          <Skeleton width="150px" height="2rem" />
          <Skeleton width="100%" height="80px" />
          <div>
            <Skeleton width="220px" height="1rem" />
            <Skeleton width="180px" height="1rem" className="mt-1" />
          </div>
          <Skeleton width="120px" height="40px" />
        </div>
      </div>
      <Divider className="border-t border-gray-400" />
      <div className="flex flex-col gap-3">
        <Skeleton width="180px" height="1rem" />
        <Skeleton width="180px" height="2rem" />
        <div>
          <Skeleton width="220px" height="1rem" />
        </div>
      </div>
    </div>
  );
}
